var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('enter-termination-objects-table',{attrs:{"objects-with-same-tenants":_vm.objectsWithSameTenants,"same-tenancies-by-object":_vm.sameTenanciesByObject,"object-id":_vm.objectId},on:{"selected-object":_vm.selectedObject}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }